__webpack_require__.p = "https://pralnia-v2.swps-pjatk-experiment.com/";